if (!customElements.get('illegal-night-product-form')) {
  customElements.define(
    'illegal-night-product-form',
    class IllegalNightProductForm extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.productDetails = this.closest('[data-product-details]');
        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-inp-current-variant]');
        this.offerInputs = Array.from(this.querySelectorAll('input[name="purchase_offer"]'));
        this.addButton = this.querySelector('[data-inp-add]');
        this.buyNowButton = this.querySelector('[data-inp-buy-now]');
        this.quantityInput = this.productDetails?.querySelector('[data-inp-quantity-input]');
        this.quantityMinus = this.productDetails?.querySelector('[data-inp-quantity-minus]');
        this.quantityPlus = this.productDetails?.querySelector('[data-inp-quantity-plus]');
        this.selectedPrice = this.querySelector('[data-inp-selected-price]');
        this.errorBox = this.querySelector('[data-inp-error]');
        this.cart = document.querySelector('cart-drawer');
        this.sectionRoot = this.closest('.section--illegal-night-product');
        this.productHero = this.sectionRoot?.querySelector('.inp-product__page');
        this.stickyTrigger = this.sectionRoot?.querySelector('[data-inp-sticky-trigger]');
        this.stickyCart = this.sectionRoot?.querySelector('[data-inp-sticky-cart]');
        this.stickyAddButton = this.stickyCart?.querySelector('[data-inp-sticky-add]');
        this.stickyVariantSelect = this.stickyCart?.querySelector('[data-inp-sticky-variant]');
        this.stickyPrice = this.stickyCart?.querySelector('[data-inp-sticky-price]');
        this.stickyBundleLabel = this.stickyCart?.querySelector('[data-inp-sticky-bundle-label]');
        this.pageFooter = document.querySelector('.in-footer');
        this.mobileStickyQuery = window.matchMedia('(max-width: 749px)');
        this.variants = this.readVariants();
        this.loading = false;
        this.stickyVisibilityFrame = null;

        this.onSubmitBound = this.onSubmit.bind(this);
        this.onAddClickBound = this.onAddClick.bind(this);
        this.onOfferChangeBound = this.onOfferChange.bind(this);
        this.onVariantInputChangeBound = this.syncCurrentVariant.bind(this);
        this.onQuantityMinusBound = () => this.setQuantity(this.quantity - 1);
        this.onQuantityPlusBound = () => this.setQuantity(this.quantity + 1);
        this.onQuantityChangeBound = () => this.setQuantity(this.quantity);
        this.onBuyNowBound = this.onBuyNow.bind(this);
        this.onStickyAddBound = () => this.addSelectedOffer(this.stickyAddButton);
        this.onStickyVariantChangeBound = this.onStickyVariantChange.bind(this);
        this.onStickyViewportChangeBound = this.scheduleStickyVisibility.bind(this);

        this.form?.addEventListener('submit', this.onSubmitBound);
        this.addButton?.addEventListener('click', this.onAddClickBound);
        this.offerInputs.forEach((input) => input.addEventListener('change', this.onOfferChangeBound));
        this.variantInput?.addEventListener('change', this.onVariantInputChangeBound);
        this.quantityMinus?.addEventListener('click', this.onQuantityMinusBound);
        this.quantityPlus?.addEventListener('click', this.onQuantityPlusBound);
        this.quantityInput?.addEventListener('change', this.onQuantityChangeBound);
        this.buyNowButton?.addEventListener('click', this.onBuyNowBound);
        this.stickyAddButton?.addEventListener('click', this.onStickyAddBound);
        this.stickyVariantSelect?.addEventListener('change', this.onStickyVariantChangeBound);
        window.addEventListener('scroll', this.onStickyViewportChangeBound, { passive: true });
        window.addEventListener('resize', this.onStickyViewportChangeBound, { passive: true });

        if ('ResizeObserver' in window && this.productHero) {
          this.stickyResizeObserver = new ResizeObserver(this.onStickyViewportChangeBound);
          this.stickyResizeObserver.observe(this.productHero);
          if (this.stickyTrigger) this.stickyResizeObserver.observe(this.stickyTrigger);

          const header = document.querySelector('.shopify-section-header');
          if (header) this.stickyResizeObserver.observe(header);
        }

        this.preloadGalleryImages();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantSelection = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            ({ data }) => {
              if (data?.sectionId !== this.dataset.sectionId) return;
              this.setActionsTemporarilyDisabled(true);
            },
          );
        }

        if (this.stickyCart) this.stickyCart.hidden = false;
        this.syncCurrentVariant();
        this.scheduleStickyVisibility();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmitBound);
        this.addButton?.removeEventListener('click', this.onAddClickBound);
        this.offerInputs?.forEach((input) => input.removeEventListener('change', this.onOfferChangeBound));
        this.variantInput?.removeEventListener('change', this.onVariantInputChangeBound);
        this.quantityMinus?.removeEventListener('click', this.onQuantityMinusBound);
        this.quantityPlus?.removeEventListener('click', this.onQuantityPlusBound);
        this.quantityInput?.removeEventListener('change', this.onQuantityChangeBound);
        this.buyNowButton?.removeEventListener('click', this.onBuyNowBound);
        this.stickyAddButton?.removeEventListener('click', this.onStickyAddBound);
        this.stickyVariantSelect?.removeEventListener('change', this.onStickyVariantChangeBound);
        window.removeEventListener('scroll', this.onStickyViewportChangeBound);
        window.removeEventListener('resize', this.onStickyViewportChangeBound);
        this.stickyResizeObserver?.disconnect();
        this.unsubscribeVariantSelection?.();

        if (this.stickyVisibilityFrame) window.cancelAnimationFrame(this.stickyVisibilityFrame);
        if (this.galleryIdleHandle && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(this.galleryIdleHandle);
        }
        if (this.galleryPreloadTimer) window.clearTimeout(this.galleryPreloadTimer);
        this.galleryPreloads = [];
      }

      scheduleStickyVisibility() {
        if (!this.stickyCart || !this.productHero || this.stickyVisibilityFrame) return;

        this.stickyVisibilityFrame = window.requestAnimationFrame(() => {
          this.stickyVisibilityFrame = null;
          this.updateStickyVisibility();
        });
      }

      updateStickyVisibility() {
        if (!this.stickyCart || !this.productHero) return;

        const triggerTop = this.stickyTrigger
          ? this.stickyTrigger.getBoundingClientRect().top
          : this.productHero.getBoundingClientRect().bottom;
        const passedProductHero = triggerTop <= window.innerHeight;
        const footerReached =
          this.mobileStickyQuery.matches &&
          this.pageFooter &&
          this.pageFooter.getBoundingClientRect().top <= window.innerHeight;
        const shouldShow = passedProductHero && !footerReached;

        this.stickyCart.classList.toggle('is-visible', shouldShow);
        this.stickyCart.setAttribute('aria-hidden', String(!shouldShow));
      }

      onStickyVariantChange() {
        if (!this.stickyVariantSelect || !this.variantInput) return;

        const variantId = Number(this.stickyVariantSelect.value);
        const variant = this.variants.find((item) => Number(item.id) === variantId);
        if (!variant?.available) return;

        this.variantInput.value = String(variant.id);
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      preloadGalleryImages() {
        const productRoot = this.closest('.inp-product');
        const gallery = productRoot?.querySelector('embla-component.product-gallery__carousel');
        const images = Array.from(gallery?.querySelectorAll('.embla__slide img') || []);

        if (images.length < 2) return;

        this.galleryPreloads = [];
        images.slice(1, 4).forEach((image) => this.preloadGalleryImage(image, 'high'));

        const preloadRemaining = () => {
          images.slice(4).forEach((image) => this.preloadGalleryImage(image, 'auto'));
        };

        if ('requestIdleCallback' in window) {
          this.galleryIdleHandle = window.requestIdleCallback(preloadRemaining, { timeout: 600 });
        } else {
          this.galleryPreloadTimer = window.setTimeout(preloadRemaining, 180);
        }
      }

      preloadGalleryImage(image, priority) {
        image.loading = 'eager';
        image.fetchPriority = priority;

        if (image.complete) return;

        const preload = new Image();
        preload.decoding = 'async';
        preload.fetchPriority = priority;
        if (image.sizes) preload.sizes = image.sizes;
        if (image.srcset) preload.srcset = image.srcset;
        preload.src = image.currentSrc || image.src;
        this.galleryPreloads.push(preload);
      }

      readVariants() {
        const data = this.querySelector('[data-inp-variants]');
        if (!data) return [];

        try {
          return JSON.parse(data.textContent);
        } catch (error) {
          console.error('Illegal Night: nie udało się odczytać wariantów produktu.', error);
          return [];
        }
      }

      get currentVariant() {
        const variantId = Number(this.variantInput?.value);
        return this.variants.find((variant) => Number(variant.id) === variantId) || null;
      }

      get selectedOffer() {
        const input = this.offerInputs.find((offerInput) => offerInput.checked && !offerInput.disabled);
        return input?.closest('.inp-offer') || null;
      }

      get quantity() {
        const minimum = Number(this.quantityInput?.min || 1);
        const maximum = Number(this.quantityInput?.max || 99);
        const value = Number.parseInt(this.quantityInput?.value || minimum, 10);
        return Math.min(maximum, Math.max(minimum, Number.isFinite(value) ? value : minimum));
      }

      setQuantity(value) {
        if (!this.quantityInput) return;

        const minimum = Number(this.quantityInput.min || 1);
        const maximum = Number(this.quantityInput.max || 99);
        const nextValue = Math.min(maximum, Math.max(minimum, Number.parseInt(value, 10) || minimum));
        this.quantityInput.value = String(nextValue);
        this.updateAllOfferPrices();
        this.updateActionState();
      }

      syncCurrentVariant() {
        const variant = this.currentVariant;
        const currentAvailable = Boolean(variant?.available);
        const addonAvailable = this.dataset.addonAvailable === 'true';
        const addonPrice = Number(this.dataset.addonPrice || 0);
        const addonComparePrice = Number(this.dataset.addonComparePrice || addonPrice);

        if (variant && this.stickyVariantSelect) {
          this.stickyVariantSelect.value = String(variant.id);
        }

        this.querySelectorAll('.inp-offer').forEach((offer) => {
          const input = offer.querySelector('input[name="purchase_offer"]');
          const kind = offer.dataset.offerKind;
          const usesCurrentVariant = offer.dataset.useCurrentVariant === 'true';
          let price = Number(offer.dataset.price || 0);
          let comparePrice = Number(offer.dataset.comparePrice || 0);
          let available = offer.dataset.fixedAvailable === 'true';

          if (usesCurrentVariant && variant) {
            available = currentAvailable;

            if (kind === 'bundle') {
              price = Number(variant.price) + addonPrice;
              comparePrice = Number(variant.price) + addonComparePrice;
              available = currentAvailable && addonAvailable && Boolean(offer.dataset.addonVariantId);
            } else if (kind === 'pack-one') {
              price = Number(variant.price);
              if (Number(variant.compare_at_price) > Number(variant.price)) {
                comparePrice = Number(variant.compare_at_price);
              }
            } else {
              price = Number(variant.price);
              comparePrice = Number(variant.compare_at_price || 0);
            }
          } else if (usesCurrentVariant && !variant) {
            available = false;
          }

          offer.dataset.price = String(price);
          offer.dataset.comparePrice = String(comparePrice);
          input.disabled = !available;
          this.updateOfferPrice(offer, price, comparePrice);
        });

        this.ensureAvailableOfferSelected();
        this.setActionsTemporarilyDisabled(false);
        this.updateActionState();
      }

      updateAllOfferPrices() {
        this.querySelectorAll('.inp-offer').forEach((offer) => {
          const unitPrice = Number(offer.dataset.price || 0);
          const unitComparePrice = Number(offer.dataset.comparePrice || 0);
          this.updateOfferPrice(offer, unitPrice, unitComparePrice);
        });
      }

      updateOfferPrice(offer, unitPrice, unitComparePrice) {
        const priceElement = offer.querySelector('[data-offer-price]');
        const compareElement = offer.querySelector('[data-offer-compare]');
        const quantity = this.quantity;
        const totalPrice = unitPrice * quantity;
        const totalComparePrice = unitComparePrice * quantity;

        if (priceElement) priceElement.textContent = this.formatMoney(totalPrice);
        if (compareElement) {
          compareElement.textContent = this.formatMoney(totalComparePrice);
          compareElement.hidden = !(unitComparePrice > unitPrice);
        }
      }

      ensureAvailableOfferSelected() {
        const selectedInput = this.offerInputs.find((input) => input.checked);
        if (selectedInput && !selectedInput.disabled) return;

        const firstAvailable = this.offerInputs.find((input) => !input.disabled);
        if (firstAvailable) firstAvailable.checked = true;
      }

      onOfferChange() {
        this.clearError();
        this.updateActionState();
      }

      updateActionState() {
        const offer = this.selectedOffer;
        const items = this.getSelectedItems();
        const enabled = Boolean(offer && items.length && !this.loading);
        const unitPrice = Number(offer?.dataset.price || 0);
        const totalPrice = unitPrice * this.quantity;

        if (this.selectedPrice) this.selectedPrice.textContent = this.formatMoney(totalPrice);
        if (this.stickyPrice) this.stickyPrice.textContent = this.formatMoney(totalPrice);
        if (this.stickyBundleLabel) {
          this.stickyBundleLabel.hidden = offer?.dataset.offerKind !== 'bundle';
        }
        if (this.addButton) {
          this.addButton.disabled = !enabled;
          this.addButton.setAttribute('aria-disabled', String(!enabled));
        }
        if (this.buyNowButton) {
          this.buyNowButton.disabled = !enabled;
          this.buyNowButton.setAttribute('aria-disabled', String(!enabled));
        }
        if (this.stickyAddButton) {
          this.stickyAddButton.disabled = !enabled;
          this.stickyAddButton.setAttribute('aria-disabled', String(!enabled));
        }
        if (this.stickyVariantSelect) this.stickyVariantSelect.disabled = this.loading;
        this.updateQuantityState(enabled);
      }

      updateQuantityState(enabled) {
        const quantity = this.quantity;
        const minimum = Number(this.quantityInput?.min || 1);
        const maximum = Number(this.quantityInput?.max || 99);

        if (this.quantityInput) this.quantityInput.disabled = !enabled;
        if (this.quantityMinus) this.quantityMinus.disabled = !enabled || quantity <= minimum;
        if (this.quantityPlus) this.quantityPlus.disabled = !enabled || quantity >= maximum;
      }

      getSelectedItems() {
        const offer = this.selectedOffer;
        if (!offer) return [];

        const kind = offer.dataset.offerKind;
        const currentVariantId = Number(this.variantInput?.value);
        const fixedVariantId = Number(offer.dataset.fixedVariantId);
        const addonVariantId = Number(offer.dataset.addonVariantId || this.dataset.addonVariantId);
        const usesCurrentVariant = offer.dataset.useCurrentVariant === 'true';
        const quantity = this.quantity;
        const items = [];

        if (kind === 'base') {
          if (currentVariantId) items.push({ id: currentVariantId, quantity });
        } else if (kind === 'bundle') {
          if (currentVariantId) items.push({ id: currentVariantId, quantity });
          if (addonVariantId) items.push({ id: addonVariantId, quantity });
        } else if (usesCurrentVariant) {
          if (currentVariantId) items.push({ id: currentVariantId, quantity });
        } else if (fixedVariantId) {
          items.push({ id: fixedVariantId, quantity });
        }

        return this.combineDuplicateItems(items);
      }

      combineDuplicateItems(items) {
        const combined = new Map();
        items.forEach((item) => {
          combined.set(item.id, (combined.get(item.id) || 0) + item.quantity);
        });

        return Array.from(combined, ([id, quantity]) => ({ id, quantity }));
      }

      onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.addSelectedOffer(this.addButton);
      }

      onAddClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.addSelectedOffer(this.addButton);
      }

      onBuyNow(event) {
        event.preventDefault();
        event.stopPropagation();

        const items = this.getSelectedItems();
        if (!items.length) {
          this.showError('Wybierz dostępną opcję zakupu.');
          return;
        }

        this.clearError();
        const cartUrl = (this.dataset.cartUrl || window.routes?.cart_url || '/cart').replace(/\/$/, '');
        const cartLines = items.map((item) => `${item.id}:${item.quantity}`).join(',');
        window.location.assign(`${cartUrl}/${cartLines}?checkout`);
      }

      async addSelectedOffer(trigger, redirectToCheckout = false) {
        if (this.loading) return;

        const items = this.getSelectedItems();
        if (!items.length) {
          this.showError('Wybierz dostępną opcję zakupu.');
          return;
        }

        this.clearError();
        this.setLoading(true, trigger);

        try {
          const payload = { items };
          const canUseCartDrawer =
            !redirectToCheckout &&
            this.cart &&
            typeof this.cart.getSectionsToRender === 'function' &&
            typeof this.cart.renderContents === 'function';

          if (canUseCartDrawer) {
            payload.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',');
            payload.sections_url = window.location.pathname;
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(trigger || document.activeElement);
            }
          }

          const cartAddUrl = this.dataset.cartAddUrl || window.routes?.cart_add_url || '/cart/add.js';
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Nie udało się dodać produktu do koszyka.');
          }

          if (redirectToCheckout) {
            window.location.assign(this.dataset.checkoutUrl || '/checkout');
          } else if (canUseCartDrawer) {
            this.cart.classList.remove('is-empty');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'illegal-night-product-form',
                cartData: result,
              });
            }
            this.cart.renderContents(result);
          } else {
            window.location.assign(this.dataset.cartUrl || window.routes?.cart_url || '/cart');
          }
        } catch (error) {
          this.showError(error.message || 'Wystąpił błąd. Spróbuj ponownie.');
        } finally {
          this.setLoading(false, trigger);
        }
      }

      setLoading(isLoading, trigger) {
        this.loading = isLoading;
        this.addButton?.classList.toggle('is-loading', isLoading && this.addButton === trigger);
        this.buyNowButton?.classList.toggle('is-loading', isLoading && this.buyNowButton === trigger);
        this.stickyAddButton?.classList.toggle(
          'is-loading',
          isLoading && this.stickyAddButton === trigger,
        );
        this.updateActionState();
      }

      setActionsTemporarilyDisabled(disabled) {
        if (!disabled) return;
        if (this.addButton) {
          this.addButton.disabled = true;
          this.addButton.setAttribute('aria-disabled', 'true');
        }
        if (this.buyNowButton) {
          this.buyNowButton.disabled = true;
          this.buyNowButton.setAttribute('aria-disabled', 'true');
        }
        if (this.stickyAddButton) {
          this.stickyAddButton.disabled = true;
          this.stickyAddButton.setAttribute('aria-disabled', 'true');
        }
        if (this.stickyVariantSelect) this.stickyVariantSelect.disabled = true;
        this.updateQuantityState(false);
      }

      showError(message) {
        if (!this.errorBox) return;
        this.errorBox.textContent = message;
        this.errorBox.hidden = false;
        this.errorBox.focus?.();
      }

      clearError() {
        if (!this.errorBox) return;
        this.errorBox.textContent = '';
        this.errorBox.hidden = true;
      }

      formatMoney(cents) {
        const value = Number(cents || 0);
        const format = this.dataset.moneyFormat || '{{amount_with_comma_separator}} zł';
        const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount_with_comma_separator';
        let formatted;

        switch (placeholder) {
          case 'amount':
            formatted = this.formatWithDelimiters(value, 2, '.', ',');
            break;
          case 'amount_no_decimals':
            formatted = this.formatWithDelimiters(value, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            formatted = this.formatWithDelimiters(value, 0, ',', '.');
            break;
          case 'amount_with_apostrophe_separator':
            formatted = this.formatWithDelimiters(value, 2, '.', "'");
            break;
          case 'amount_with_space_separator':
            formatted = this.formatWithDelimiters(value, 2, ',', ' ');
            break;
          case 'amount_no_decimals_with_space_separator':
            formatted = this.formatWithDelimiters(value, 0, ',', ' ');
            break;
          case 'amount_with_comma_separator':
          default:
            formatted = this.formatWithDelimiters(value, 2, ',', '.');
            break;
        }

        const output = format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
        const template = document.createElement('template');
        template.innerHTML = output;
        return template.content.textContent.trim();
      }

      formatWithDelimiters(cents, precision, decimal, thousands) {
        const amount = (cents / 100).toFixed(precision);
        const parts = amount.split('.');
        const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        return parts[1] ? `${whole}${decimal}${parts[1]}` : whole;
      }
    },
  );
}

if (!customElements.get('illegal-night-recently-viewed')) {
  customElements.define(
    'illegal-night-recently-viewed',
    class IllegalNightRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.container = this.querySelector('[data-recently-viewed-container]');
        this.sectionId = this.dataset.sectionId;
        this.currentId = Number(this.dataset.currentId);
        this.maxItems = Math.max(1, Number.parseInt(this.dataset.maxItems, 10) || 4);
        this.storageKey = 'recently-viewed-ids';
        this.load();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      readStoredIds() {
        try {
          const stored = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
          if (!Array.isArray(stored)) return [];

          return stored
            .map((id) => Number(id))
            .filter((id, index, items) => Number.isFinite(id) && id > 0 && items.indexOf(id) === index);
        } catch (error) {
          return [];
        }
      }

      storeCurrentProduct(ids) {
        if (!this.currentId) return ids;

        const updated = [this.currentId, ...ids.filter((id) => id !== this.currentId)].slice(
          0,
          this.maxItems + 1,
        );

        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(updated));
        } catch (error) {
          // Brak dostępu do localStorage nie powinien blokować reszty strony produktu.
        }

        return updated;
      }

      async load() {
        if (!this.container || !this.sectionId) {
          this.hidden = true;
          return;
        }

        const storedIds = this.storeCurrentProduct(this.readStoredIds());
        const idsToLoad = storedIds
          .filter((id) => id !== this.currentId)
          .slice(0, this.maxItems);

        if (!idsToLoad.length) {
          this.hidden = true;
          return;
        }

        const searchQuery = idsToLoad.map((id) => `id:${id}`).join(' OR ');
        const root = window.Shopify?.routes?.root || '/';
        const url =
          `${root}search?type=product&q=${encodeURIComponent(searchQuery)}` +
          `&section_id=${encodeURIComponent(this.sectionId)}`;

        this.abortController = new AbortController();

        try {
          const response = await fetch(url, {
            headers: { Accept: 'text/html' },
            signal: this.abortController.signal,
          });

          if (!response.ok) throw new Error(`Recently viewed request failed: ${response.status}`);

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const itemTemplates = Array.from(
            documentFragment.querySelectorAll('template[data-inp-recent-item]'),
          );

          const cards = itemTemplates
            .map((template) => template.content.firstElementChild?.cloneNode(true))
            .filter(Boolean)
            .slice(0, this.maxItems);

          if (!cards.length) {
            this.hidden = true;
            return;
          }

          this.container.replaceChildren(...cards);
          this.hidden = false;
          this.dispatchEvent(new CustomEvent('illegal-night-recently-viewed:ready'));
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Illegal Night recently viewed error:', error);
          }
          this.hidden = true;
        }
      }
    },
  );
}
